import React from "react";
import StoreLayout from "../components/StoreLayout";

export default function Terms() {
  return (
    <StoreLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10 py-16">
        <p className="label-mono text-[#71717A]">// LEGAL</p>
        <h1 className="font-display font-black text-4xl md:text-6xl uppercase tracking-tight mt-3">Terms &amp; Conditions</h1>
        <p className="label-mono text-[#71717A] mt-2">LAST UPDATED // 23 MAY 2026</p>

        <div className="mt-10 space-y-8 text-[#A1A1AA] leading-relaxed">

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">1. Acceptance</h2>
            <p>By accessing or using <span className="text-[#CFF048]">cultlyf.com</span> (the “Site”) you agree to these Terms &amp; Conditions. If you don’t agree, please do not use the Site or place an order.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">2. Eligibility</h2>
            <p>You must be at least 18 years old (or have permission from a parent/guardian) and capable of forming a binding contract to place an order.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">3. Account</h2>
            <p>Signing up is mandatory to place an order. You are responsible for keeping your login credentials confidential and for everything that happens under your account. Notify us immediately if you suspect unauthorised access.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">4. Products &amp; pricing</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>All prices are in Indian Rupees (₹) and inclusive of applicable taxes unless stated otherwise.</li>
              <li>Colours, fabric texture and print placement may vary slightly from on-screen images due to display and manufacturing variances.</li>
              <li>Stock is limited; an item in your cart is not reserved until payment is completed.</li>
              <li>We may correct any error in pricing or product description and cancel affected orders with a full refund.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">5. Orders &amp; payment</h2>
            <p>Orders are confirmed only after successful payment via our payment processor (Stripe). On confirmation you’ll receive an email with order details. We reserve the right to refuse or cancel any order for reasons including stock unavailability, payment failure or suspected fraud.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">6. Shipping</h2>
            <p>Estimated delivery is 3–7 business days from confirmation. You’ll receive courier name and tracking number by email once your order is shipped. Cult Lyf is not responsible for delivery delays caused by courier partners or events outside our control.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">7. Returns &amp; exchanges</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>Size-exchange requests must be raised within <strong className="text-white">7 days</strong> of delivery. Item must be unworn, unwashed and in original packaging with tags attached.</li>
              <li>Refunds for defective or wrong items received are issued within 7 business days of receiving the returned item.</li>
              <li>Limited / drop items, customised mockups, and items on sale are <strong className="text-white">non-returnable</strong>.</li>
              <li>To start a return, email <span className="text-[#CFF048]">info@cultlyf.com</span> with your order ID and photos.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">8. Intellectual property</h2>
            <p>All artwork, prints, logos, photography and copy on the Site are owned by Cult Lyf or licensed to us. You may not copy, reproduce, modify or distribute any of it without our written permission.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">9. User content (reviews)</h2>
            <p>When you post a review, rating or comment, you grant Cult Lyf a non-exclusive, royalty-free, worldwide license to display, edit and use it for marketing. You confirm that the content is your own and doesn’t violate any third-party rights, and is free of unlawful, offensive or spam content.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">10. Acceptable use</h2>
            <p>You agree not to misuse the Site, attempt to bypass security, scrape data, upload malicious code, or otherwise interfere with other users’ experience. We may suspend or terminate accounts that violate these terms.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">11. Limitation of liability</h2>
            <p>To the maximum extent permitted by law, Cult Lyf’s total liability for any claim arising out of an order is limited to the amount you paid for that order. We are not liable for indirect, incidental or consequential damages.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">12. Governing law</h2>
            <p>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts at the seller’s registered location.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">13. Changes</h2>
            <p>We may update these Terms from time to time. The “last updated” date will reflect any changes. Continuing to use the Site after changes means you accept the updated Terms.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">14. Contact</h2>
            <p>Questions? Email <span className="text-[#CFF048]">info@cultlyf.com</span>.</p>
          </section>

        </div>
      </div>
    </StoreLayout>
  );
}
